export default function About() {
  return (
    <section className="static-page">
      <p className="chapter-tag"><em>Chapter</em> · About</p>
      <h1 className="page-h1" data-testid="about-heading">About Bhoomiza Organics</h1>
      <p className="page-lead">
        Bhoomiza Organics is a Jaipur-based Indian natural products brand focused on bringing plant-based products closer to everyday consumers.
      </p>
      <div className="static-grid">
        <article>
          <h2>The Brand</h2>
          <p>Bhoomiza Organics is an Indian natural products brand focused on bringing plant-based products closer to everyday consumers. Our range — from Moringa Powder to dehydrated fruit chips, vegetable chips, natural fruit &amp; vegetable powders and Moringa Sweets — reflects our focus on natural ingredients, simple nutrition and quality-focused products.</p>
        </article>
        <article>
          <h2>Rooted in Jaipur</h2>
          <p>We are a Jaipur-based brand offering natural products for customers looking for plant-based additions to their everyday routine. Our goal is to make quality Moringa Powder and other natural products easily accessible to customers in Jaipur and across India.</p>
        </article>
        <article>
          <h2>Across India</h2>
          <p>Bhoomiza Organics delivers Moringa Powder, dehydrated fruit chips, vegetable chips, natural powders and Moringa Sweets to customers across India. Our products are designed as convenient additions to an everyday balanced lifestyle.</p>
        </article>
        <article>
          <h2>Made with care</h2>
          <p>Every product is made with carefully selected ingredients and naturally processed. We do not make medical claims — we simply offer plant-based, thoughtfully packed products for everyday use.</p>
        </article>
      </div>
    </section>
  );
}
